module.exports = __webpack_public_path__ + "static/media/SDFSA_8-509w.e32ebde7.webp";